import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DataField } from './DataFieldBase';

@Injectable()
export class DataFieldControlService {
  constructor() { }

  toFormGroup(fields: any ) {
    let group: any = {};

    fields.forEach(field => {
      field.forms.forEach(field => {
        group[field.key] = field.required ? new FormControl(field.value || '', Validators.required) : new FormControl(field.value || '');
      })
    });
    return new FormGroup(group);
  }
}